import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import styled from 'styled-components';
import { f as focusOutline } from '../theme/style-mixins/FocusIndicator/focusOutline-oDdaDZ4N.js';
import { T as TaktIdProvider } from '../TaktIdContext/TaktIdContext-C6vdL-6Z.js';
import { c as createStormTaktId } from '../TaktIdContext/TaktIdContext.utils-B0CzqlN8.js';

const TabbedCardItemContainer = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-40025937__sc-bmmkx8-0"
})(["outline:none;position:relative;:focus-visible{", "}"], focusOutline);
TabbedCardItemContainer.displayName = 'TabbedCardItemContainer';
const TabbedCardItem = ({
  children,
  taktId,
  taktValue,
  value,
  ...rest
}) => /*#__PURE__*/React__default.createElement(TaktIdProvider, {
  taktId: taktId,
  taktValue: taktValue,
  fallbackId: createStormTaktId('tabbed-card-item')
}, /*#__PURE__*/React__default.createElement(TabbedCardItemContainer, _extends({}, rest, {
  role: "tabpanel",
  "aria-labelledby": value,
  "data-testid": `tab-panel-${value}`
}), children));

export { TabbedCardItem as T };
//# sourceMappingURL=TabbedCardItem-CGm8ejpU.js.map
